import styled from "styled-components";

export const StyledForm = styled.form`
    width: 396px;
    max-width: 100%;
    padding: 42px 22px;
    background-color: var(--color-grey-3);
    border-radius: 4px;

    display: flex;
    flex-direction: column;

    gap:25px;

    h1{
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        color: var(--color-grey-0);
        text-align: center;
    }
`